export const phonePortraitWidth = 480
export const phoneLandscapeWidth = 960